import React from 'react';
import { Box, Radio, RadioGroup } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';

const radioGroupStyles = {
  '.chakra-radio__input': {
    background: Colors.ArmyGreen900,
  },
  '.chakra-radio__control': {
    background: Colors.White,
    borderColor: Colors.ArmyGreen300,
    width: '18px',
    height: '18px',
  },
  '.chakra-radio__control:hover': {
    background: Colors.White,
    borderColor: Colors.ForestGreen900,
  },
  '.chakra-radio__control[data-checked]': {
    borderColor: Colors.ForestGreen900,
    color: Colors.ForestGreen900,
  },
  '.chakra-radio__control[data-checked]:hover': {
    borderColor: Colors.ForestGreen900,
    color: Colors.ForestGreen900,
  },
};

const optionContainer = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  pl: 'padding_12',
  pr: 'padding_12',
  pt: 'padding_4',
  pb: 'padding_4',
  _hover: {
    background: 'brand.army-100',
  },
};

const optionText = {
  letterSpacing: '-0.13px',
  fontSize: '13px',
  color: 'brand.army-dark',
  ml: 'padding_8',
};

type RadioOption = {
  value: string;
  label: string;
};

type RadioButtonsProps = {
  value: string;
  onChange: (value: string) => void;
  options: RadioOption[];
  /** Optional extra sx for the root RadioGroup container */
  sx?: Record<string, unknown>;
};

const RadioButtons = ({ value, onChange, options, sx = {} }: RadioButtonsProps) => {
  return (
    <RadioGroup value={value} onChange={onChange} sx={{ ...radioGroupStyles, ...sx }}>
      {options.map((option) => (
        <Box key={option.value} sx={optionContainer}>
          <Radio value={option.value} colorScheme="whiteAlpha">
            <Text as="div" sx={optionText}>
              {option.label}
            </Text>
          </Radio>
        </Box>
      ))}
    </RadioGroup>
  );
};

export default RadioButtons;
